module.exports = __webpack_public_path__ + "img/kachel-ALLERGIEN_PRO12.f3cf3948.png";